import * as types from './constants';

// Get Regularusers Group
export const getRegularusersGroupRequest = data => (
  { type: types.GET_REGULARUSERS_GROUP_REQUEST, payload: data }
);

export const getRegularusersGroupDone = data => (
  { type: types.GET_REGULARUSERS_GROUP_DONE, payload: data }
);

export const getRegularusersGroupFailed = errors => (
  { type: types.GET_REGULARUSERS_GROUP_FAILED, payload: errors }
);